function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19 11H7.14l3.63-4.36a1 1 0 10-1.54-1.28l-5 6a1.19 1.19 0 00-.09.15c0 .05 0 .08-.07.13A1 1 0 004 12a1 1 0 00.07.36c0 .05 0 .08.07.13a1.19 1.19 0 00.09.15l5 6A1 1 0 0010 19a1 1 0 00.64-.23 1 1 0 00.13-1.41L7.14 13H19a1 1 0 000-2z",
  "data-name": "arrow-back"
}));

function SvgIconArrowBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGcgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBkYXRhLW5hbWU9ImFycm93LWJhY2siPjxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdHJhbnNmb3JtPSJyb3RhdGUoOTAgMTIgMTIpIiBvcGFjaXR5PSIwIi8+PHBhdGggZD0iTTE5IDExSDcuMTRsMy42My00LjM2YTEgMSAwIDEgMC0xLjU0LTEuMjhsLTUgNmExLjE5IDEuMTkgMCAwIDAtLjA5LjE1YzAgLjA1IDAgLjA4LS4wNy4xM0ExIDEgMCAwIDAgNCAxMmExIDEgMCAwIDAgLjA3LjM2YzAgLjA1IDAgLjA4LjA3LjEzYTEuMTkgMS4xOSAwIDAgMCAuMDkuMTVsNSA2QTEgMSAwIDAgMCAxMCAxOWExIDEgMCAwIDAgLjY0LS4yMyAxIDEgMCAwIDAgLjEzLTEuNDFMNy4xNCAxM0gxOWExIDEgMCAwIDAgMC0yeiIvPjwvZz48L2c+PC9zdmc+";
export { SvgIconArrowBack as ReactComponent };